module.exports = "/**\r\n * @license\r\n * Copyright Akveo. All Rights Reserved.\r\n * Licensed under the MIT License. See License.txt in the project root for license information.\r\n */\n:host .links {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n:host .form-group:last-of-type {\n  margin-bottom: 3rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/framework/auth/components/request-password/request-password.component.scss
// module id = ./src/framework/auth/components/request-password/request-password.component.scss
// module chunks = main